module.exports = __webpack_public_path__ + "img/H1.6ab91273.png";